import { useState, useEffect, useRef } from "react";
import { Button, Offcanvas } from "react-bootstrap";

import { Property } from "components/Editor/components/properties";

import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  fetchPageHealth,
  updateActivePageHealthCategory,
  updatePageHealthScoreCanonicalURL,
  updatePageHealthShowSEORecommendation,
} from "actions/pageHealth";

import cx from "classnames";

import styles from "./pageHealth.module.scss";

import {
  IMAGE_SIZE,
  URL_LENGTH,
  TITLE_LENGTH,
  METADATA_LENGTH,
  METADATA_TAGS,
  SOCIAL_TITLE,
  SOCIAL_DESCRIPTION,
  SOCIAL_IMAGE,
  TWITTER_TITLE,
  TWITTER_DESCRIPTION,
  TWITTER_IMAGE,
  MISSING_ALT_TAGS,
} from "constants/pageHealth";
import { selectWidget } from "actions/editor";
import { useLocation } from "react-router-dom";

export default function PageHealth({
  storyboardType,
  editorSession,
  pageId,
  breakpoint,
  handlePageSettings,
}) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const interactive_active_uid = queryParams.get("active") || "";

  const pageHealth = useSelector((state) => state.pages.pageHealth);
  const page = useSelector((state) =>
      _.get(state, `pages.page.${pageId}.item`, {})
  );
  const seoToggle = _.get(page, "seoToggle", false);
  const {
    activeCategory,
    pageHealthScore,
    performanceWarnings,
    seoWarnings,
    canonical
  } = pageHealth || {};

  const dispatch = useDispatch();

  const widgets = useSelector((state) =>
    _.get(state, `${editorSession}.present.widgets`, [])
  );

  const [offSet, setOffset] = useState(133);
  const [showPageHealth, setShowPageHealth] = useState(false);

  const pageHealthCalculated = useRef(false);

  const editorRef = useRef({
    editorSession,
    storyboardType,
    pageId,
    interactive_active_uid,
  });

  useEffect(() => {
    dispatch(updatePageHealthScoreCanonicalURL(""));
  }, [pageId]);

  useEffect(() => {
    if(!(editorSession && storyboardType && pageId)) return;

    editorRef.current = {
      editorSession,
      storyboardType,
      pageId,
      interactive_active_uid,
    };
    
    if(!editorSession?.includes(`${pageId}`)) return;

    if(pageHealthCalculated.current) return;

    if (editorSession && storyboardType && pageId) {
      dispatch(
        fetchPageHealth(
          editorSession,
          storyboardType,
          pageId,
          interactive_active_uid
        )
      );

      pageHealthCalculated.current = true;
    }
  }, [editorSession, storyboardType, pageId, interactive_active_uid, pageHealthCalculated]);

  // WHEN OPEN PAGE HEALTH
  useEffect(() => {
    if (!showPageHealth) return;

    const { editorSession, storyboardType, pageId, interactive_active_uid } = editorRef.current;

    if (editorSession && storyboardType && pageId) {
      dispatch(
        fetchPageHealth(
          editorSession,
          storyboardType,
          pageId,
          interactive_active_uid
        )
      );
    }
  }, [showPageHealth, seoToggle, canonical, editorRef]);

  useEffect(() => {
    setShowPageHealth(false);
  }, [breakpoint]);

  const handleALTTags = (warning) => {
    const uid = _.get(warning, "widget_uid", "");
    const widget = widgets.find((widget) => widget.uid === uid);
    if (widget) {
      dispatch(selectWidget(editorSession, [widget.uid]));
      document.getElementById(widget.uid)?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  };

  return (
    <>
      <HealthButton
        showPageHealth={showPageHealth}
        setShowPageHealth={setShowPageHealth}
        pageHealthScore={pageHealthScore}
        setOffset={setOffset}
      />
      {showPageHealth && (
        <Offcanvas
          className={styles.pageHealthContainer}
          show={true}
          id="page-health-offcanvas"
          backdrop={false}
          enforceFocus={false}
          autoFocus={false}
          restoreFocus={false}
          keyboard={true}
          onHide={() => setShowPageHealth(false)}
          placement="end"
          style={{
            top: offSet,
            width: "351px",
          }}
        >
          <Offcanvas.Header className={styles.pageHealthHeader}>
            <Offcanvas.Title className={styles.pageHealthHeaderTitle}>
              {`Page Health`}
            </Offcanvas.Title>
            {
              <div className={styles.ignoreBtnContainer}>
                {/* <div
                className={styles.ignoreBtnWrapper}
                variant="info"
                // onClick={() => dispatch(updatePageHealthShowIgnoredStatus())}
              >
                <i
                  className={
                    showIgnored ? "cleverstory-view" : "cleverstory-hide"
                  }
                />
                <p>{showIgnored ? `Hide Ignored` : `Show Ignored`}</p>
              </div> */}
                <Button
                  className={styles.close}
                  variant="info"
                  onClick={() => setShowPageHealth(false)}
                >
                  <i className="cleverstory-close" />
                </Button>
              </div>
            }
          </Offcanvas.Header>
          <div className={styles.performanceContainer}>
            <div
              className={cx(styles.performanceWrapper, {
                [styles.performanceWrapperSelected]:
                  activeCategory === "performance",
              })}
              onClick={() =>
                dispatch(updateActivePageHealthCategory("performance"))
              }
            >
              <p className={styles.performanceTitle}>
                {/* <span>{`${performance.totalScore}%`}</span> */}
                <p>Performance</p>
              </p>
              {/* <ProgressBar
                variant="warning"
                className={styles.performaceProgressLoader}
                now={performance.totalScore}
              /> */}
            </div>
            <div
              className={cx(styles.performanceWrapper, {
                [styles.performanceWrapperSelected]: activeCategory === "seo",
              })}
              onClick={() => dispatch(updateActivePageHealthCategory("seo"))}
            >
              <p className={styles.performanceTitle}>
                {/* <span>{`${seo.totalScore}%`}</span> */}
                <p style={{ marginRight: "-5px" }}>
                  <span>SEO</span>
                  {/* <ToolTipComponent /> */}
                </p>
              </p>
              {/* <ProgressBar
                variant="warning"
                className={styles.performaceProgressLoader}
                // now={seo.totalScore}
              /> */}
            </div>
          </div>
          {activeCategory === "seo" && (
            <div className={styles.toggleWrapper}>
              <p>Show SEO Recommendations</p>
              <Property.Switch
                id="seo-element"
                title={""}
                value={seoToggle}
                onChange={() =>
                  dispatch(updatePageHealthShowSEORecommendation(pageId, !seoToggle))
                }
                className={styles.switch}
              />
            </div>
          )}
          <Offcanvas.Body className={styles.pageHealthWrapper}>
            <div className={styles.warningListContainer}>
              {activeCategory === "performance" &&
                performanceWarnings.map((warning) => (
                  <WarningList
                    {...warning}
                    activeCategory={activeCategory}
                    handleALTTags={handleALTTags}
                    handlePageSettings={() => {
                      setShowPageHealth(false);
                      handlePageSettings();
                    }}
                  />
                ))}

              {activeCategory === "seo" &&
                seoToggle &&
                seoWarnings.map((warning) => (
                  <WarningList
                    {...warning}
                    activeCategory={activeCategory}
                    handleALTTags={() => handleALTTags(warning)}
                    handlePageSettings={() => {
                      setShowPageHealth(false);
                      handlePageSettings();
                    }}
                  />
                ))}

              {((activeCategory === "seo" &&
                (seoWarnings.length === 0 || !seoToggle)) ||
                (activeCategory === "performance" &&
                  performanceWarnings.length === 0)) && (
                <div className={styles.emptyContainer}>
                  <img
                    className={styles.emptyImage}
                    src="/images/pageHealthEmpty.svg"
                    alt="No more suggestions"
                    width={66}
                    height={66}
                  />
                  <p>
                    {
                      activeCategory === "seo" && !seoToggle && 
                      <>
                      SEO Checks Disabled
                      <span>SEO checks are turned off. These properties won’t affect Page Health if you don’t intend to index.Turn them on to monitor SEO performance.</span> 
                      </>
                    }
                    {
                      activeCategory === "seo" && seoWarnings.length === 0 && seoToggle && 
                      <>
                      SEO Looks Good!
                      <span>No issues found! Your page meets SEO best practices.</span> 
                      </>
                    }
                    {
                      activeCategory === "performance" && performanceWarnings.length === 0 && 
                      <>
                      Great Performance!
                      <span>Your page looks good! No performance issues detected.</span> 
                      </>
                    }
                  </p>
                </div>
              )}
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
    </>
  );
}

function HealthButton({
  showPageHealth,
  setShowPageHealth,
  pageHealthScore,
  setOffset,
}) {
  const buttonRef = useRef(null);

  useEffect(() => {
    const selectedButton = buttonRef.current;
    if (selectedButton) {
      const rect = selectedButton.getBoundingClientRect();
      const offsetValue = rect.y + rect.height;
      setOffset(offsetValue);
    }
  }, [buttonRef.current]);

  return (
    <div
      className={styles.pageHealthBtnWrapper}
      ref={buttonRef}
      id={"button-page-health"}
    >
      <span
        className={cx(styles.pageHealthBtn, {
          [styles.active]: showPageHealth,
        })}
        onClick={() => setShowPageHealth(true)}
        data-track-event="Mixpanel" data-track-props="Page Health"
      >
        Page Health:{" "}
        <span className={styles.score}>{Math.round(pageHealthScore || 0)}</span>
      </span>
    </div>
  );
}

function WarningList({
  title,
  warningTag,
  criticality,
  type,
  message,
  handlePageSettings,
  handleALTTags,
  activeCategory
}) {
  return (
    <div className={styles.warningListWrapper}>
      <div className={styles.warningHeader}>
        <p>
          {title}{" "}
          <span
            className={cx({
              [styles.warningTagHigh]: criticality === "high",
              [styles.warningTagMedium]: criticality === "medium",
              [styles.warningTagLow]: criticality === "low",
            })}
          >
            {warningTag}
          </span>
        </p>
        {/* <ToolTipComponent /> */}
      </div>
      <div
        className={styles.warningMessage}
        dangerouslySetInnerHTML={{ __html: message }}
      />
      {activeCategory === "seo" && (
        <>
          <div className={styles.warningFooter}>
            <WarningFooter
              type={type}
              handlePageSettings={handlePageSettings}
              handleALTTags={handleALTTags}
            />
            {/* <Button
          variant="secondary"
          // onClick={() =>
          //   dispatch(updatePageHealthIgnoredItem(id, true))
          // }
        >
          Ignore
        </Button>
        <p>
          <i className="cleverstory-top" />
          <span>20%</span>
        </p> */}
          </div>
        </>
      )}
      <hr />
    </div>
  );
}

const WarningFooter = ({ type, handlePageSettings, handleALTTags }) => {
  const getSettings = () => {
    switch (type) {
      case MISSING_ALT_TAGS:
        return {
          name: "Add ALT Tags",
          action: handleALTTags,
        };
      case IMAGE_SIZE:
      case URL_LENGTH:
      case TITLE_LENGTH:
      case METADATA_LENGTH:
      case METADATA_TAGS:
      case SOCIAL_TITLE:
      case SOCIAL_DESCRIPTION:
      case SOCIAL_IMAGE:
      case TWITTER_TITLE:
      case TWITTER_DESCRIPTION:
      case TWITTER_IMAGE:
        return {
          name: "Open Page Settings",
          action: handlePageSettings,
        };
      default:
        return {
          name: null,
          action: () => console.warn("No action assigned"),
        };
    }
  };

  const { name, action } = getSettings(); // Extract name and action once

  if (!name) return null;

  return (
    <Button variant={"primary"} onClick={action}>
      {name}
    </Button>
  );
};

// function ToolTipComponent() {
//   const [showTooltip, setShowTooltip] = useState(false);
//   const target = useRef(null);
//   return (
//     <>
//       <Button
//         variant="info"
//         onMouseEnter={() => setShowTooltip(true)}
//         onMouseLeave={() => setShowTooltip(false)}
//         ref={target}
//       >
//         <i
//           className={"cleverstory-info"}
//           style={{ fontSize: "15px", color: "#616161" }}
//         />
//       </Button>
//       <Overlay
//         show={showTooltip}
//         target={target.current}
//         container={document.body} // ✅ Ensures correct positioning
//         flip={false} // ✅ Prevents repositioning issues
//         placement="left"
//         delay={{ show: 250, hide: 400 }}
//         style={{ marginLeft: "10px" }}
//       >
//         {(props) => (
//           <Tooltip
//             id="tooltip-right"
//             {...props}
//             style={{ ...props.style, zIndex: 9999 }}
//           >
//             Tooltip inside Offcanvas
//           </Tooltip>
//         )}
//       </Overlay>
//     </>
//   );
// }
